import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Col, Row, Container, Button } from "react-bootstrap";
import TitleBar from "../components/TitleBar";
import { HotelContext } from '../context/hotel';
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import { useNavigate } from 'react-router-dom';

const System = () => {
  const navigate = useNavigate();
  // const { data : hotel } = useSelector(state => state.hotelReducer);
  const { data: hotel, getUrlPath } = useContext(HotelContext)
  const { RoomOccupation, WebPush, setShowRequestPermission } = useContext(UserContext)
  const { data: checkIn, stayClear } = useContext(CheckInContext)

  const [ endPoint, setEndPoint ] = useState(null);
  // const { checkIn } = useSelector(state => state.checkInReducer);
  // const dispatch = useDispatch()

  // const goLogout = useCallback(() => {
  //   history.replace(`/${hotel.code}/logout`)
  // }, []);
  useEffect(() => {
    console.log('aaaaaaaa')
    navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {

      // alert('serviceWorkerRegistration');
    //   // alert(JSON.stringify(serviceWorkerRegistration))
    //   // alert('PushManager')
    //   // alert(serviceWorkerRegistration.pushManager)


    //   console.log('aaaaa - serviceWorkerRegistration', serviceWorkerRegistration);

      if ('pushManager' in serviceWorkerRegistration) {
          serviceWorkerRegistration.pushManager
              .getSubscription()
              .then((subscription) => {
                setEndPoint(subscription?.endpoint)
              })
      }
    })
  }, []);

  return (
    <Container className="page-container page-profile">
      <TitleBar transparent={false} />
      <Row className="page-header">
        <Col>
          <h1>DEBUG System</h1>
          <p>Hotel {hotel.code}</p>

          <h5>CheckIn</h5>
          {checkIn?.id && <>
            <h6>{checkIn.id}</h6>
            {checkIn.passengers[0] && <h6>A nombre de {checkIn.passengers[0].surname}, {checkIn.passengers[0].name}. - para el día {new Date(checkIn.dateStart + 'T00:00:00').toLocaleDateString('es-AR')}</h6>}
            <h6>{checkIn.subscriptions.join(' / ')}</h6>
          </>}
          {!checkIn?.id && <h6>No CheckIn</h6>}

          <h5>Estadía</h5>
          {RoomOccupation?.id && <>
            <h6>{RoomOccupation.id}</h6>
          </>}
          {!RoomOccupation?.id && <h6>No estadía</h6>}

          <h5>Web Push ID</h5>
          <p>{WebPush?.subscription?.endpoint === endPoint ? 'OK' : 'Error' }</p>
          <h6>{WebPush?.id ?? '-'}</h6>
          <h6>{WebPush?.subscription && JSON.stringify(WebPush.subscription)}</h6>
          {endPoint && <h6>{endPoint}</h6>}

          {/* <Button size={'lg'} variant={'primary'} type={'button'} block={true}
                          onClick={() => goLogout()}>Salir de la Estadía???????</Button> */}

<Button
              size={'lg'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              onClick={() => {
                stayClear()
                navigate(getUrlPath('/'))
              }}>
                Resetea Data
            </Button>

            <Button
              size={'lg'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              onClick={() => {
                if (navigator.serviceWorker) {
                  alert('a');
                  alert(navigator.serviceWorker.controller.postMessage);
                  navigator.serviceWorker.controller?.postMessage({
                      type: 'TEST_PUSH',
                      payload: { 
                          title: "Prueba de Push",
                          text: "Esto es una prueba de llamada a push directa desde el código"
                      }
                  });
                }
              }}>
                Test Push
            </Button>

            <Button
              size={'lg'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              onClick={() => {
                // if (navigator.serviceWorker) {
                //   navigator.serviceWorker.controller?.postMessage({
                //       type: 'SAVE_DATA',
                //       payload: { 
                //           hola: "123",
                //           chau: "789"
                //       }
                //   });
                // }
                const value = Math.floor(Math.random() * 50) + 1;
                fetch('token', { method: "POST", body: JSON.stringify({ token: value })}).then(() => {
                  alert('SAVE_DATA - saved to cache - token ' + value)
                });
              }}>
                Save Data.
            </Button>

            <Button
              size={'lg'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              onClick={() => {
                // if (navigator.serviceWorker) {

                //   navigator.serviceWorker.controller?.postMessage({
                //       type: 'GET_DATA'
                //   });
                // }
                fetch('token').then(response => response.json()).then(data => {
                  alert('SAVE_DATA - Got ' + JSON.stringify(data) + ' from cache')
                });
                  
                //   response.json()).then(data => {
                //   alert('SAVE_DATA - Got ' + JSON.stringify(data) + ' from cache');
                // });
              }}>
                Get Data
            </Button>

        </Col>
      </Row>
      <br />
      <br />
      <br />
      <br />
      <br />


              <h1>H1 Style</h1>
              <h2>H2 Style</h2>
              <h3>H3 Style</h3>
              <h4>H4 Style</h4>
              <h5>H5 Style</h5>
              <h6>H6 Style</h6>
              <span className={`label label-sm label-light-pending label-inline`}>Label Light SM</span>
              <span className={`label label-md label-light-pending label-inline`}>Label Light MD</span>
              <span className={`label label-lg label-light-pending label-inline`}>Label Light LG</span>
              <hr />
              <p className="general-title">Título</p>
              <p className="general-subtitle">Subtítulo</p>
              <p className="general-text">Texto general</p>
              <p className="font-size-xs">font-size-xs</p>
              <p className="font-size-sm">font-size-sm</p>
              <p className="font-size-normal">font-size-normal</p>
              <p className="font-size-md">font-size-md</p>
              <p className="font-size-lg">font-size-lg</p>
              <p className="font-size-xl">font-size-xl</p>
      {/* <div className="footer-container">
            <Button
              size={'lg'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              onClick={() => dispatch({ type: 'RESTART_DATA' })}>
                Resetea Data
            </Button>
          </div> */}
    </Container>
  );
}

export default System;